const env = process.env;

export default env;